export const DOCUMENT_WATCH_CHECK_IS_ARCHIVED = 'container/DocumentStatusPage/DOCUMENT_WATCH_CHECK__IS_ARCHIVED';
export const FETCH_DOCUMENT_ARCHIVED = 'status/FETCH_DOCUMENT_ARCHIVED';
export const FETCH_DOCUMENT_ARCHIVED_ERROR = 'status/FETCH_DOCUMENT_ARCHIVED_ERROR';
export const FETCH_DOCUMENT_ARCHIVED_SUCCESS = 'status/FETCH_DOCUMENT_ARCHIVED_SUCCESS';
